/**
 * @module ol/source/WMTSRequestEncoding
 */

/**
 * Request encoding. One of 'KVP', 'REST'.
 * @enum {string}
 */
export default {
  KVP: 'KVP', // see spec §8
  REST: 'REST' // see spec §10
};

//# sourceMappingURL=WMTSRequestEncoding.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/source/WMTSRequestEncoding.js
// module id = ../../../../ol/source/WMTSRequestEncoding.js
// module chunks = 3